// traceability: requirements: [FR-017]
import { useTranslation } from 'react-i18next';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { clsx } from 'clsx';
import { SUPPORTED_LANGUAGES } from '@/types/i18n';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) ?? SUPPORTED_LANGUAGES[0];

  const handleChange = (code: string) => {
    void i18n.changeLanguage(code);
    localStorage.setItem('tcm-language', code);
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          className={clsx(
            'inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium',
            'text-zinc-600 hover:bg-zinc-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-jade-500',
            'dark:text-zinc-300 dark:hover:bg-zinc-800',
          )}
          aria-label="Change language"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="shrink-0">
            <circle cx="12" cy="12" r="10" />
            <line x1="2" y1="12" x2="22" y2="12" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          </svg>
          {current?.label}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className={clsx(
            'z-50 min-w-[140px] rounded-lg border border-zinc-200 bg-white p-1 shadow-lg',
            'dark:border-zinc-700 dark:bg-zinc-900',
          )}
          sideOffset={4}
          align="end"
        >
          {SUPPORTED_LANGUAGES.map((lang) => (
            <DropdownMenu.Item
              key={lang.code}
              className={clsx(
                'flex cursor-pointer select-none items-center rounded-md px-3 py-2 text-sm outline-none',
                'hover:bg-jade-50 focus:bg-jade-50 dark:hover:bg-zinc-800 dark:focus:bg-zinc-800',
                i18n.language === lang.code
                  ? 'font-medium text-jade-700 dark:text-jade-400'
                  : 'text-zinc-700 dark:text-zinc-300',
              )}
              onSelect={() => handleChange(lang.code)}
            >
              {lang.label}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
